window.addEventListener('DOMContentLoaded', () => {
    /**
     * Replaces AOS (change animations in _animations.scss)
     * How to use: add data-animation to element
     * options: 'fade-up', 'fade-down'
     * 
     * // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API 
     * // https://blog.webdevsimplified.com/2022-01/intersection-observer/
     * 
     * @param {*} entries 
     * @param {*} observer 
     */
    function animation_Observer( entries, observer ){

        entries.forEach( entry => {
            if(entry.isIntersecting){
                
                if( [ 'fade-up', 'fade-down' ].includes( entry.target.dataset.animation ) ){
                    entry.target.style.transform = "translateY(0, 0, 0)";
                }

                entry.target.style.opacity = "1";
                observer.unobserve(entry.target);
            }
        });

    }

    function init_animations(){

        // DOM elements
        let elements = document.querySelectorAll('[data-animation]');
        const observer = new IntersectionObserver( animation_Observer, { threshold: 0.50 });
        
        if( ! elements ){
            return observer.disconnect();
        }
        
        elements.forEach( element => observer.observe(element) );

    }

    function add_animations_to_elements(blocks){

        if( ! blocks ){
            return;
        }

        blocks.forEach( block => {
            let elements = document.querySelectorAll( block.selector );
            elements.forEach( element => {
                if( typeof element.dataset.animation === "undefined"){
                    element.dataset.animation = block.animation;
                }
            });
        });

    }

    add_animations_to_elements([
        { selector: '.wp-block-cover__inner-container', animation: 'fade-down' },
    ]);

    init_animations();

});
